import { CaseTypeRepository } from '@telespot/domain';

export interface ICountCaseTypesByAssetTypeQuery {
  /**
   * Counts case types referencing the given asset type (transitively, through
   * the method types associated with that asset type). Repository errors
   * propagate so the caller can update its error state.
   */
  execute(assetTypeId: string): Promise<number>;
}

export class CountCaseTypesByAssetTypeQuery implements ICountCaseTypesByAssetTypeQuery {
  constructor(private readonly caseTypeRepository: CaseTypeRepository) {}

  public async execute(assetTypeId: string): Promise<number> {
    return this.caseTypeRepository.countForAssetType(assetTypeId);
  }
}
